import { NgModule, ModuleWithProviders, SkipSelf, Optional } from '@angular/core';
import { PlatformDefinitionsApiConfiguration } from './configuration';
import { HttpClient } from '@angular/common/http';


@NgModule({
  imports:      [],
  declarations: [],
  exports:      [],
  providers: []
})
export class PlatformDefinitionsApiModule {
    public static forRoot(configurationFactory: () => PlatformDefinitionsApiConfiguration): ModuleWithProviders<PlatformDefinitionsApiModule> {
        return {
            ngModule: PlatformDefinitionsApiModule,
            providers: [ { provide: PlatformDefinitionsApiConfiguration, useFactory: configurationFactory } ]
        };
    }

    constructor( @Optional() @SkipSelf() parentModule: PlatformDefinitionsApiModule,
                 @Optional() http: HttpClient) {
        if (parentModule) {
            throw new Error('PlatformDefinitionsApiModule is already loaded. Import in your base AppModule only.');
        }
        if (!http) {
            throw new Error('You need to import the HttpClientModule in your AppModule! \n' +
            'See also https://github.com/angular/angular/issues/20575');
        }
    }
}
